<script setup lang="ts">
interface IProps {
  width?: number
  height?: number
  path?: string
}

const props = withDefaults(defineProps<IProps>(), {
  width: 24,
  height: 24,
  path: ''
})
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path v-if="path" :d="props.path" />
    <slot />
  </svg>
</template>
